import { useEffect } from 'react';

export function useUnmount(effect) {
  useEffect(() => effect, []);
}
